import { isUserLookingAtThisTab } from './isUserLookingAtThisTab';
import {
  isSuggestionAudioUnlocked,
  playSuggestionSound,
} from './suggestionSound';
import {
  applyIncomingSuggestion,
  countUnseen,
  hasAttentionItems,
  removeUnseen,
  type SuggestionTabAlertsState,
  shouldPlaySound,
  stampSound,
} from './suggestionTabAlertsState';
import { updateSuggestionTabAlertsState } from './suggestionTabAlertsStorage';
import { useSuggestionTabAlertsStore } from '../../store/SuggestionTabAlerts/useSuggestionTabAlertsStore';

type TabAlert = {
  userId: string;
  key: string;
  createdAt: number;
  soundEnabled: boolean;
};

export const publishTabAlertState = (state: SuggestionTabAlertsState) =>
  useSuggestionTabAlertsStore.getState().setUnseen({
    count: countUnseen(state),
    hasAttention: hasAttentionItems(state),
  });

export async function recordTabAlert({
  userId,
  key,
  createdAt,
  soundEnabled,
}: TabAlert) {
  const now = Date.now();
  const state = await updateSuggestionTabAlertsState(userId, (current) => {
    const next = applyIncomingSuggestion(current, {
      entryId: key,
      createdAt,
      isThisTabVisible: isUserLookingAtThisTab(),
      now,
    });
    if (
      soundEnabled &&
      isSuggestionAudioUnlocked() &&
      shouldPlaySound(next, now)
    ) {
      return { next: stampSound(next, now), effect: playSuggestionSound };
    }
    return { next };
  });
  publishTabAlertState(state);
}

export async function removeTabAlert(userId: string, key: string) {
  const state = await updateSuggestionTabAlertsState(userId, (current) => ({
    next: removeUnseen(current, key),
  }));
  publishTabAlertState(state);
}
